import { render, staticRenderFns } from "./HeaderSpacer.vue?vue&type=template&id=266e2eca&scoped=true&"
import script from "./HeaderSpacer.vue?vue&type=script&lang=js&"
export * from "./HeaderSpacer.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSpacer.vue?vue&type=style&index=0&id=266e2eca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266e2eca",
  null
  
)

export default component.exports